import { useCallback } from 'react';
import { expression, isCorrectUrl } from 'app/shared/utils/is-correct-url';

export interface TextWithLinksProps {
  text: string | undefined;
  viewDetailText: string;
  onLinkClick?: (linkUrl: string) => void;
}

export const getRelationshipAttribute = (url: string): string => {
  if (/^https?:\/\/www.videos-vno.com\/?/.test(url)) {
    return 'noopener';
  }

  return 'noreferrer noopener';
};

interface DescriptionLinkProps {
  url: string;
  label: string;
  onLinkClick?: (linkUrl: string) => void;
}

const DescriptionLink = ({ url, label, onLinkClick }: DescriptionLinkProps): JSX.Element => {
  const handleClick = useCallback(() => onLinkClick?.(url), [onLinkClick, url]);

  return (
    // eslint-disable-next-line react/jsx-no-target-blank
    <a href={url} target="_blank" rel={getRelationshipAttribute(url)} onClick={handleClick}>
      {label}
    </a>
  );
};

export const TextWithLinks = ({ text, viewDetailText, onLinkClick }: TextWithLinksProps): JSX.Element => {
  const urlRegExp = new RegExp(expression);

  return (
    <span className="leading-5">
      {text?.split(urlRegExp).map((part) => {
        if (isCorrectUrl(part)) {
          return <DescriptionLink url={part} label={viewDetailText} onLinkClick={onLinkClick} key={part} />;
        }
        return part;
      })}
    </span>
  );
};
